export default {
  Purchase_advise: 'Purchase advise',
  Out_of_stock_Qty: 'Out of stock Qty',
  Advised_purchase_Qty: 'Advised purchase Qty',
  SKU_no: 'SKU code.',
  SKU_name: 'SKU name',
  SPU_no: 'SPU code.',
  SPU_name: 'SPU name',
  Supplier: 'Supplier',
  SKU_Status: 'SKU Status',
  Purchase_strategy: 'Purchase strategy',
  Batch_Search: 'Batch Search',
  System_order_no: 'System order no.',
  SKU_info: 'SKU info.',
  Category: 'Category',
  Brand: 'Brand',
  Purchase_order_info: 'Purchase order info.',
  Warehouse: 'Warehouse',
  Current_stock: 'Current stock',
  Available_stock: 'Available stock',
  Purchase_in_transit: 'Purchase in transit',
  EST_days_available: 'EST days available',
  EST_stock_available: 'EST stock available',
  Operation_info: 'Operation info.',
  Out_of_stock_order_no: 'Out of stock order no.',
  Not_on_due: 'Not on due',
  On_due: 'On due',
  Image: 'Image',
  Bar_code: 'Bar code',
  Non_arrived_Qty: 'Non arrived Qty',
  Non_stock_in_Qty: 'Non stock-in Qty',
  Return_in_transit: 'Return in transit',
  Preparation_time: 'Preparation time',
  Out_of_stock_in_X_days: 'Out of stock in X days',
  Out_of_stock_order_Qty: 'Out of stock order Qty',
  seven_day_sales_average_total: '7-day sales (average/total)',
  fourteen_day_sales_average_total: '14-day sales (average/total)',
  thirty_day_sales_average_total: '30-day sales (average/total)',
  Sales_trend: 'Sales trend',
  EST_daily_sales: 'EST daily sales',
  Refresh_time: 'Refresh time',
  Operation: 'Operation',
  New_purchase_plan: 'New purchase plan',
  New_purchase_order: 'New purchase order',
  Set_advise_strategy: 'Set advise strategy',
  Refresh: 'Refresh',
  Customised_search_setting: 'Customised search setting',
  Set_SKU_status: 'Set SKU status',
  Set_sales_trend_rules: 'Set sales trend rules',
  Download: 'Download',
  Hot: 'Hot',
  Dump: 'Dump',
  New: 'New',
  Priority: 'Priority',
  Time: 'Time',
  recent_N_days: 'recent N days',
  Sales_range: 'Sales range',
  Stock_range: 'Stock range',
  SKU_new_N_days_are_NEW: 'SKU new N days are NEW',
  Enable_status: 'Enable status',
  Sales_trend_tip1: 'Sales trend is calculated by last 7-day dales, the slope is the sales trend',
  Sales_trend_tip2: 'The unit length of X axis affects the accuracy of sales trend',
  Sales_trend_tip3: 'You can set the x-axis unit length in batches through this entry, or you can set the x-axis unit length of certain piece of data'

}
